/// <amd-module name="Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataReducer" />
import { default as produce } from "immer";
import { ITfsPageData } from "Tfs/Platform/Page";
import { TfsPageDataAction, TfsPageDataActionTypes } from "Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataActions";

export function tfsPageDataReducer(state: ITfsPageData, action: TfsPageDataAction): ITfsPageData {
    return produce(state || null, draft => {
        switch (action.type) {
            case TfsPageDataActionTypes.TfsPageDataInitialized: {
                return action.payload;
            }
        }
    });
}
